import { Dialogs } from '@leverege/ui-elements';
import { DataSources } from '@leverege/ui-attributes';
import { Context } from '@leverege/plugin';
import { GlobalState } from '@leverege/ui-redux';
import ResetLocation from './ResetLocation';
export default {
  id: 'recovr.action.location.reset',
  name: 'Reset Location',
  matches: {
    use: ['contextMenu'],
    path: 'location',
    objectType: 'location'
  },
  handles: cxt => {
    const contextExists = !!Context.getTargetsOfType(cxt, 'location')?.[0];
    const persona = GlobalState.get()?.ui?.activePersona?.name;
    return contextExists && (persona === 'default' || persona === 'salesperson');
  },
  layout: {
    sort: 'zzzzzz'
  },
  appearance: () => {
    return {
      name: 'Reset Location',
      icon: 'fa fa-plus fa-fw'
    };
  },
  perform: ({
    context
  }) => {
    const {
      mobile
    } = context.clientProps;
    const item = Context.getTargetsOfType(context, 'location')?.[0];
    const actions = DataSources.getActions(item);
    Dialogs.show({
      id: 'resetLocation',
      component: ResetLocation,
      props: {
        actions,
        item,
        mobile
      }
    });
  }
};